import { ResetPassword as ResetPasswordComponent } from "../components/ResetPassword";

export const ResetPassword = () => {
  return <ResetPasswordComponent />;
};
